<script>
import TiptapEditor from '@shared/components/TiptapEditor.vue';
import VueSimpleEmbed from '@shared/components/VueSimpleEmbed.vue';

export default {
  components: {
    TiptapEditor,
    VueSimpleEmbed,
  },
  head() {
    return {
      title: `Description - ${this.membership ? this.membership.name : 'Plan'}`,
    };
  },
  data() {
    return {
      isLoading: false,
      videoPreviewUrl: '',
      membership: {
        summary: '',
        promotional_video_url: '',
        description: '',
        goals: '',
        target: '',
        requirements: '',
      },
    };
  },
  computed: {
    currentMembership() {
      return this.$store.state.memberships.current;
    },
    authStore() {
      return this.$store.getters['auth/store'];
    },
    pageURL() {
      let p = '';

      if (this.currentMembership.status === 'DRAFT') {
        p = `?p=${this.$store.state.auth.previewToken}`;
      }

      return `${this.$store.getters['auth/url']}/abonnements/${this.currentMembership.slug}${p}`;
    },
  },
  // watch: {
  //   currentSubscription: {
  //     handler(newVal) {
  //       if (newVal && newVal.uuid) {
  //         this.hydrateData();
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  // async created() {
  //   console.log('Created - currentSubscription before load:', this.currentSubscription);
  //   await this.loadSubscription();
  //   console.log('Created - currentSubscription after load:', this.currentSubscription);
  //   this.hydrateData();
  // },
  created() {
    this.hydrateData();
  },
  methods: {
    hydrateData() {
      if (!this.currentMembership) return;

      // Map the current membership data to local membership object
      Object.keys(this.membership).forEach((key) => {
        this.membership[key] = this.currentMembership[key] || this.membership[key];
      });

      this.videoPreviewUrl = this.membership.promotional_video_url;
    },
    handle() {
      const membershipData = { ...this.membership };
      this.isLoading = true;
      this.$store.dispatch('memberships/update', {
        uuid: this.currentMembership.uuid,
        membershipData,
        isCurrent: true,
      })
        .then(() => {
          this.videoPreviewUrl = this.membership.promotional_video_url;
          this.$showMessage.success();
        })
        .finally(() => (this.isLoading = false));
    },
    handleDescriptions() {
      const membershipData = {
        summary: this.membership.summary,
        description: this.membership.description,
      };
      this.isLoading = true;
      this.$store.dispatch('memberships/update', {
        uuid: this.currentMembership.uuid,
        membershipData,
        isCurrent: true,
      })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading = false));
    },
    handleGoals() {
      const membershipData = { goals: this.membership.goals };
      this.isLoading = true;
      this.$store.dispatch('memberships/update', {
        uuid: this.currentMembership.uuid,
        membershipData,
        isCurrent: true,
      })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading = false));
    },
    handleTarget() {
      const membershipData = { target: this.membership.target };
      this.isLoading = true;
      this.$store.dispatch('memberships/update', {
        uuid: this.currentMembership.uuid,
        membershipData,
        isCurrent: true,
      })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading = false));
    },
    handleRequirements() {
      const membershipData = { requirements: this.membership.requirements };
      this.isLoading = true;
      this.$store.dispatch('memberships/update', {
        uuid: this.currentMembership.uuid,
        membershipData,
        isCurrent: true,
      })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <div class="columns is-multiline">
    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Vidéo de présentation
      </h2>
      <p>
        Ajoutez une vidéo de présentation de votre page, à travers
        un lien <strong>YouTube</strong>, <strong>Vimeo</strong>,
        ou <strong>Dailymotion</strong>.
      </p>
      <p>Une vidéo de présentation rendra votre page plus dynamique !</p>
      <p class="has-text-weight-bold">
        Votre page est accessible en <a :href="pageURL" target="_blank">cliquant ici</a>.
      </p>
      <p>
        Ce champ est facultatif.
      </p>
    </div>

    <div class="column is-8">
      <form class="box" @submit.prevent="dataIsValid(isLoading) && handle()">
        <b-field>
          <b-input type="url" pattern="https?://.+" placeholder="Lien vers la vidéo"
            v-model="membership.promotional_video_url" />
        </b-field>

        <div v-if="videoPreviewUrl" class="field">
          <VueSimpleEmbed class="has-text-centered" :attrs="{
            class: 'mw-full mx-auto',
            width: '560',
            height: '315'
          }" :url="videoPreviewUrl">
            <b-notification type="is-danger" :closable="false">
              Il y a eu un problème de chargement...
            </b-notification>
          </VueSimpleEmbed>
        </div>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </div>

    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Description
      </h2>
      <p>
        Décrivez votre plan d'abonnement pour donner envie aux apprenants de s'abonner.
      </p>
      <p class="has-text-weight-bold">
        Ce texte apparaîtra dans votre page
        accessible en <a :href="pageURL" target="_blank">cliquant ici</a>.
      </p>
      <p>
        Ce champ est facultatif.
      </p>
    </div>

    <div class="column is-8">
      <form class="box" @submit.prevent="dataIsValid(isLoading) && handleDescriptions()">
        <b-field>
          <template #label>
            Description courte (apparaît dans les listes)
          </template>
          <b-input type="textarea" placeholder="Décrivez le plan d'abonnement en une ou deux phrases maximum"
            maxlength="200" v-model="membership.summary" />
        </b-field>

        <b-field class="mt-5">
          <template #label>
            Description longue (apparaît dans la fiche)
          </template>

          <TiptapEditor ref="description" :value="membership.description" :hidden="['h2']"
            @input="membership.description = $event" />
        </b-field>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </div>

    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Objectifs
      </h2>
      <p>
        Décrivez les objectifs et avantages de l'abonnement.
        Soyez le plus factuel et précis possible, cet élément est décisif pour les apprenants.
      </p>
      <p class="has-text-weight-bold">
        Ce texte apparaîtra dans votre page
        accessible en <a :href="pageURL" target="_blank">cliquant ici</a>.
      </p>
      <p>
        Ce champs est facultatif.
      </p>
    </div>

    <div class="column is-8">
      <form class="box" @submit.prevent="dataIsValid(isLoading) && handleGoals()">
        <b-field>
          <TiptapEditor :value="membership.goals" :hidden="['h2']" @input="membership.goals = $event" />
        </b-field>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </div>

    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Public cible
      </h2>
      <p>
        Décrivez les publics cibles de votre plan d'abonnement.
        N'hésitez pas à le faire sous forme de liste, par exemple.
      </p>
      <p class="has-text-weight-bold">
        Ce texte apparaîtra dans votre page
        accessible en <a :href="pageURL" target="_blank">cliquant ici</a>.
      </p>
      <p>
        Ce champ est facultatif.
      </p>
    </div>

    <div class="column is-8">
      <form class="box" @submit.prevent="dataIsValid(isLoading) && handleTarget()">
        <b-field>
          <TiptapEditor :value="membership.target" :hidden="['h2']" @input="membership.target = $event" />
        </b-field>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </div>

    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Prérequis
      </h2>
      <p>
        Décrivez les prérequis nécessaires pour profiter pleinement de l'abonnement.
        Là aussi, n'hésitez pas à le faire sous forme de liste.
      </p>
      <p class="has-text-weight-bold">
        Ce texte apparaîtra dans votre page
        accessible en <a :href="pageURL" target="_blank">cliquant ici</a>.
      </p>
      <p>
        Ce champ est facultatif.
      </p>
    </div>

    <div class="column is-8">
      <form class="box" @submit.prevent="dataIsValid(isLoading) && handleRequirements()">
        <b-field>
          <TiptapEditor :value="membership.requirements" :hidden="['h2']"
            @input="membership.requirements = $event" />
        </b-field>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </div>
  </div>
</template>
